export const SETUP_MODULES = [
  {
    slug: "rcc-indicator-setup",
    label: "RCC Indicator Setup",
    icon: "Network",
    description: "Configure RCC indicator groups, thresholds, and dashboard visibility.",
    summary:
      "Manage the indicator catalog used by RCC teams so scoring, labels, and reporting outputs stay aligned.",
    highlights: ["Indicator groups", "Threshold bands", "Display mapping"],
    panels: [
      {
        title: "Indicator Library",
        description: "Create or archive RCC indicators and group them by reporting area.",
      },
      {
        title: "Scoring Rules",
        description: "Define thresholds, weights, and alert rules for each indicator.",
      },
      {
        title: "Publishing Controls",
        description: "Choose where indicators appear across dashboards, reports, and exports.",
      },
    ],
  },
  {
    slug: "ohlgs-setup",
    label: "Contract Performance Setup",
    icon: "ClipboardList",
    description: "Configure the shared OHLGS KPAs and KPIs used across RCC and MMDA assessment outputs.",
    summary:
      "Manage one shared OHLGS catalog so the same KPA and KPI setup can be reused across both regional and district flows.",
    highlights: ["Shared KPA library", "Shared KPI definitions", "Cross-cutting setup"],
    panels: [
      {
        title: "KPA Library",
        description: "Create and maintain the shared OHLGS KPA groups used across the full assessment flow.",
      },
      {
        title: "KPI Definitions",
        description: "Attach KPIs, scoring guides, and scoring flags under each KPA in the shared OHLGS catalog.",
      },
      {
        title: "Output Alignment",
        description: "Keep one setup catalog aligned with both the regional and district OHLGS reporting outputs.",
      },
    ],
  },
  {
    slug: "dpat-indicator-setup",
    label: "DPAT Indicator Setup",
    icon: "Target",
    description: "Configure DPAT Section and Indicators for district performance assessment.",
    summary:
      "Manage Section and their corresponding indicators with scoring criteria and verification methods for the District Performance Assessment Tool.",
    highlights: ["Thematic Area library", "Indicator definitions", "Scoring criteria", "Means of verification"],
    panels: [
      {
        title: "Section",
        description: "Create and maintain Thematic Area groups that define the DPAT structure for development planning.",
      },
      {
        title: "Indicator Definitions",
        description: "Attach indicators, scoring criteria, means of verification, and max scores under each Thematic Area.",
      },
      {
        title: "Year-Based Planning",
        description: "Configure indicators for specific years to track performance across different planning cycles.",
      },
    ],
  },
  // {
  //   slug: "dpat-workflow",
  //   label: "DPAT Workflow",
  //   icon: "ClipboardCheck",
  //   description: "Control DPAT stages, assignments, and approval checkpoints.",
  //   summary:
  //     "Set the review flow for DPAT submissions so district teams, reviewers, and petition steps follow one path.",
  //   highlights: ["Stage sequence", "Reviewer access", "Escalation rules"],
  //   panels: [
  //     {
  //       title: "Workflow Stages",
  //       description: "Define the order of submission, review, petition, and final approval steps.",
  //     },
  //     {
  //       title: "Assignment Rules",
  //       description: "Map user roles to each DPAT action so responsibilities remain clear.",
  //     },
  //     {
  //       title: "Turnaround Targets",
  //       description: "Configure expected timelines and reminder behaviour for late actions.",
  //     },
  //   ],
  // },
  // {
  //   slug: "apr-workflow",
  //   label: "APR Workflow",
  //   icon: "GitBranch",
  //   description: "Set approval flow, review gates, and publishing controls for APR.",
  //   summary:
  //     "Coordinate APR drafting and approval so RCC teams and national reviewers work from a consistent process.",
  //   highlights: ["Approval chain", "Review status", "Release controls"],
  //   panels: [
  //     {
  //       title: "Approval Path",
  //       description: "Control how APR records move from draft to review to publication.",
  //     },
  //     {
  //       title: "Status Rules",
  //       description: "Set the statuses available to APR teams at each point in the workflow.",
  //     },
  //     {
  //       title: "Distribution Settings",
  //       description: "Choose when APR outputs become visible to downstream users and exports.",
  //     },
  //   ],
  // },
  // {
  //   slug: "data-entry-setup",
  //   label: "Data Entry Setup",
  //   icon: "Database",
  //   description: "Configure forms, defaults, and validation used across data entry screens.",
  //   summary:
  //     "Standardize data entry by defining defaults, required fields, and field-level validation rules.",
  //   highlights: ["Form defaults", "Validation rules", "Field visibility"],
  //   panels: [
  //     {
  //       title: "Form Templates",
  //       description: "Set the shared defaults and sections that appear for each data entry area.",
  //     },
  //     {
  //       title: "Validation Rules",
  //       description: "Control required fields, value limits, and inline feedback messages.",
  //     },
  //     {
  //       title: "Access Controls",
  //       description: "Restrict who can create, edit, or reopen entries after submission.",
  //     },
  //   ],
  // },
];

export const SETUP_MODULES_BY_SLUG = SETUP_MODULES.reduce((acc, moduleConfig) => {
  acc[moduleConfig.slug] = moduleConfig;
  return acc;
}, {});

export function getSetupPath(moduleSlug) {
  const safeModule = SETUP_MODULES_BY_SLUG[moduleSlug] ? moduleSlug : SETUP_MODULES[0].slug;
  return `/setup/${safeModule}`;
}